export default __webpack_public_path__ + "static/media/Bionic-Arm-01.40438072.jpg";